import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/details.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4a55e5c0")

_pushScopeId("data-v-4a55e5c0")
const _hoisted_1 = { class: "padding5px" }
const _hoisted_2 = {
  key: 0,
  class: "label-title"
}
const _hoisted_3 = { class: "label-title" }
const _hoisted_4 = {
  key: 1,
  class: "label-title"
}
const _hoisted_5 = { class: "label-title" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "width70per"
}
const _hoisted_8 = { class: "project-item-left" }
const _hoisted_9 = { class: "project-item-right" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "margin-left8px" }, "$", -1)
const _hoisted_11 = { class: "item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_activity = _resolveComponent("activity")
  const _component_card = _resolveComponent("card")
  const _component_card_dialog = _resolveComponent("card-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.showFeeType.includes(_ctx.orderDetail.TypeEnum))
        ? (_openBlock(), _createBlock("label", _hoisted_2, _toDisplayString(_ctx.orderDetail.Children.length) + " " + _toDisplayString(_ctx.$wordList.Items), 1))
        : _createCommentVNode("", true),
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$wordList.OrderTotalPrice) + " : $" + _toDisplayString(_ctx.orderDetail.OriginalPrice), 1),
      (_ctx.showFeeType.includes(_ctx.orderDetail.TypeEnum))
        ? (_openBlock(), _createBlock("label", _hoisted_4))
        : _createCommentVNode("", true),
      _createVNode("label", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextFinalPrice) + " : $" + _toDisplayString(_ctx.orderDetail.TotalPrice) + " ", 1),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_activity, {
      data: _ctx.orderDetail.Children,
      total: _ctx.orderDetail.TotalPrice,
      coupon: _ctx.orderDetail.CouponCount,
      before: _ctx.orderDetail.BeforeOncePrice
    }, null, 8, ["data", "total", "coupon", "before"]),
    (_ctx.projectUUIDSet.size===1)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_card, {
            "project-type": _ctx.orderDetail.ProjectType,
            "order-data": _ctx.orderData[_ctx.projectUUIDSet.values().next().value]
          }, null, 8, ["project-type", "order-data"])
        ]))
      : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.projectUUIDSet, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "community-info",
            key: item
          }, [
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.orderData[item].projectName), 1),
            _createVNode("label", _hoisted_9, [
              _createVNode("span", null, _toDisplayString(_ctx.$wordList.Price), 1),
              _hoisted_10,
              _createVNode("span", null, _toDisplayString(_ctx.orderData[item].price), 1),
              _createVNode("img", {
                onClick: ($event: any) => (_ctx.showCardDialog(item)),
                class: "detail-img",
                src: _imports_0
              }, null, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.orderData[item].items) + " " + _toDisplayString(_ctx.$wordList.Items), 1)
          ]))
        }), 128)),
    (_ctx.isShowCardDialog)
      ? (_openBlock(), _createBlock(_component_card_dialog, {
          key: 2,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowCardDialog=false)),
          title: _ctx.cardDialogTitle
        }, {
          default: _withId(() => [
            _createVNode(_component_card, {
              "order-data": _ctx.orderData[_ctx.cardDialogProjectUUID]
            }, null, 8, ["order-data"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
})